const BASE_FILE = 'http://www.yzzai.cn/dmz/base/file'
const BASE_ACL = 'http://www.yzzai.cn/dmz/base/acl'
const EC_BASE_ACL = 'http://www.yzzai.cn/ec/base/acl'
const EC_BASE_INFO = 'http://www.yzzai.cn/ec/base/info'
const BASE_INFO = 'http://www.yzzai.cn/ec/base/info'
const DMZ_BASE_INFO = 'http://www.yzzai.cn/dmz/base/info'
const CMC_BASE = 'http://www.yzzai.cn/dmz/cmc/base'
const CMS_DICT = 'http://www.yzzai.cn/dmz/cms/dict'
const CMS_CART = 'http://www.yzzai.cn/ec/cms/web/cart'
const CMS_FAVORITES = 'http://www.yzzai.cn/ec/cms/web/favorites'
const DMZ_PMC = 'http://www.yzzai.cn/dmz/pmc'
const PMC_DESIGNER = 'http://www.yzzai.cn/dmz/pmc/info/designer'
const MSI_BASE = 'http://www.yzzai.cn/dmz/base'
const IMS_ORDER = 'http://www.yzzai.cn/ec/ims/order'
const DMZ_MMC_MEMBER = 'http://www.yzzai.cn/dmz/mmc/info/member'
const EC_MMC_MEMBER = 'http://www.yzzai.cn/ec/mmc/info/member'
const MMC_MEMBERADDRESS = 'http://www.yzzai.cn/ec/mmc/info/memberAddress'
const CMS_CASE = 'http://www.yzzai.cn/dmz/cms/web/case'
const CMS_CASETYP = 'http://www.yzzai.cn/dmz/cms/web/caseType'
const CMS_PROJECT = 'http://www.yzzai.cn/ec/cms/web/project'
const CMS_TIPS = 'http://www.yzzai.cn/dmz/cms/web/tips'
const CMS_WY = 'http://www.yzzai.cn/dmz/cms/web'
const MSI_MIS = 'http://www.yzzai.cn/ec/ims/after'
const FINANCE_PAY = 'http://www.yzzai.cn/ec/ims/finance/receipt'
const ACCOUNT = 'http://www.yzzai.cn/ec/ims/info/account'
const BASE_PAY = 'http://www.yzzai.cn/ec/wechat/finance/pay'
const MMC_GIFT = 'http://www.yzzai.cn/ec/mmc/exchange/gift'
const MMC_EXCHANGE = 'http://www.yzzai.cn/ec/mmc/exchange'
const IMS_PAY = 'http://www.yzzai.cn/ec/ims/finance/pay'
const IMS_PRODUCT = 'http://www.yzzai.cn/dmz/pmc/info/product'
const MSI_PPRODUCT = 'http://www.yzzai.cn/dmz/pmc/info'
const MMC_POINTS = 'http://www.yzzai.cn/ec/mmc/points'
const IMS_FINANCE = 'http://www.yzzai.cn/ec/ims/finance'
const MCC_CAPAIGN = 'http://www.yzzai.cn/ec/mcc/campaign'
const EC_CMC_BASE = 'http://www.yzzai.cn/ec/cmc/base'
const CMC_DEALER = 'http://www.yzzai.cn/ec/cmc/base/dealer'
const CMC_DEARADDRESS = 'http://www.yzzai.cn/ec/cmc/base/dearAddress'
const EC_INFO = 'http://www.yzzai.cn/ec/pmc/info'
const IMS_STOCK = 'http://www.yzzai.cn/ec/ims/stock'
const CMS_WEB = 'http://www.yzzai.cn/ec/cms/web'
const IMS_PROJECT = 'http://www.yzzai.cn/ec/ims/order/project'
const EC_BASE_FILE = 'http://www.yzzai.cn/ec/base/file'
const EC_IMS_INFO = 'http://www.yzzai.cn/ec/ims/info'

// 网页管理a
const DATA_DICT = { // 数据字典
  orderUserType: 'D',
  asp: '10'
}
export default {
  BASE_INFO,
  EC_INFO,
  BASE_FILE,
  MCC_CAPAIGN,
  BASE_ACL,
  CMS_DICT,
  DMZ_PMC,
  CMS_CART,
  CMS_FAVORITES,
  MSI_BASE,
  IMS_ORDER,
  DMZ_MMC_MEMBER,
  EC_MMC_MEMBER,
  MMC_MEMBERADDRESS,
  CMS_PROJECT,
  PMC_DESIGNER,
  EC_BASE_ACL,
  EC_BASE_INFO,
  CMS_CASE,
  CMS_TIPS,
  DATA_DICT,
  EC_CMC_BASE,
  CMC_BASE,
  CMS_WY,
  MSI_MIS,
  ACCOUNT,
  FINANCE_PAY,
  CMS_CASETYP,
  BASE_PAY,
  MMC_GIFT,
  IMS_PAY,
  MSI_PPRODUCT,
  IMS_PRODUCT,
  MMC_EXCHANGE,
  MMC_POINTS,
  IMS_FINANCE,
  CMC_DEALER,
  CMC_DEARADDRESS,
  DMZ_BASE_INFO,
  IMS_STOCK,
  CMS_WEB,
  IMS_PROJECT,
  EC_BASE_FILE,
  EC_IMS_INFO
}



// WEBPACK FOOTER //
// ./src/constants/Global.constants.js